import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { toast } from 'react-toastify';
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { Loader, enumPolicies } from '../../../../_metronic/helpers'
import Resizer from "react-image-file-resizer";
import PolicyChecker from '../../../../_metronic/helpers/components/PolicyChecker';
import { useAuth } from '../../../../app/modules/auth';

import { clearState, getProduct, postProduct, patchProduct, uploadImage, getImages, deleteImage, patchImage, getVariants, postVariant, patchVariant, getOptionValues, getCategories, getSuppliers, getModels, getLookupValues } from './productActions';

// Components
import ProductGeneralSection from './components/ProductGeneralSection';
import ProductVariantsSection from './components/ProductVariantsSection';
import ProductImagesSection from './components/ProductImagesSection';

const Product = (props) => {
    //inputs from url
    const params = useParams();
    const intl = useIntl()
    const navigate = useNavigate();
    const location = useLocation();
    MenuComponent.reinitialization();

    const isDetailMode = location.pathname.includes('/detail');
    const [isEditing, setIsEditing] = useState(!isDetailMode);
    
    const { currentUser } = useAuth();
    const canEdit = currentUser?.policyIds?.some(p => [enumPolicies.ProductEdit, enumPolicies.ProductWrite].includes(p));

    //inputs from redux
    const {
        product,
        variants,
        images,
        loading,
        uploadedImageId,
        optionValues,
        categories,
        suppliers,
        models,
        productTypes,
        success
    } = props;

    //actions
    const {
        clearState,
        getProduct,
        postProduct,
        patchProduct,
        patchImage,
        uploadImage,
        getImages,
        deleteImage,
        getVariants,
        postVariant,
        patchVariant,
        getOptionValues,
        getCategories,
        getSuppliers,
        getModels,
        getLookupValues
    } = props;


    const [pageTitle, setPageTitle] = useState('Product');
    const [newVariant, setNewVariant] = useState({});
    const [myFiles, setMyFileList] = useState([])
    const [counter, setCounter] = useState(0)
    const [variantForm, setVariantForm] = useState()
    const [sequence, setSequence] = useState()

    useEffect(() => {
        if (!canEdit) {
            setIsEditing(false);
        } else {
            setIsEditing(!isDetailMode);
        }
    }, [isDetailMode, canEdit]);

    useEffect(() => {

        if (params.id > 0) {
            getProduct(params.id);
            getImages(params.id);
            getVariants(params.id);
        }

        getCategories();
        getOptionValues(1);
        getSuppliers();
        getModels();
        getLookupValues(3);

        return () => {
            clearState()
        }
    }, []);

    useEffect(() => {

        if (params.id === '0' && product && product.id > 0) {
            navigate(`/catalog-management/products/${product.id}`);
        }

    }, [product])


    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));

            if (success == 'VARIANT.CREATED.SUCESS') {
                variantForm && variantForm.reset();
            }
        }
    }, [success])

    useEffect(() => {
        if (uploadedImageId) {
            onDeleteFile(uploadedImageId);
        }
    }, [uploadedImageId])

    const breadcrumbs = [
        {
            title: intl.formatMessage({ id: 'CATALOG.MANAGEMENT.TITLE' }),
            path: '/catalog-management/products',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        }
    ]

    const validation = {
        required: {
            errorMessage: intl.formatMessage({ id: 'VALIDATION.REQUIRED_FIELD' })
        }
    }

    const handleValidSubmit = (event, values) => {
        if (product.id > 0) {
            patchProduct(product.id, { ...values })
        } else {
            postProduct({ ...values })
        }
    }

    const onDropRejected = () => {
        toast.error(intl.formatMessage({ id: 'GENERAL.FILE.INVALID' }));
    }

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                600,
                600,
                "png",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "blob"
            );
        });

    const handleAcceptedFiles = async (filesRaw) => {

        let files = []
        for (let i = 0; i < filesRaw.length; i++) {
            let f = filesRaw[i];

            var image = await resizeFile(f);
            image.name = f.name;

            var counterr = counter + 1;
            setCounter(counterr);

            files.push({
                id: image.name + "-" + counterr,
                file: image,
                name: image.name,
                actionType: 2,
                extension: image.type.split('/')[1],
            })
        }

        files.map(item =>
            Object.assign(item.file, {
                preview: item.file['type'].split('/')[0] === 'image' ? URL.createObjectURL(item.file) : null
            })
        );
        setMyFileList(files)
    };

    const onSaveFile = (id) => {
        var file = myFiles.find(s => s.id == id);
        uploadImage(params.id, file);
    }

    const onDeleteExistFile = (id) => {
        deleteImage(params.id, id)
    }

    const onDeleteFile = (id) => {
        var files = [...myFiles].filter(s => s.id != id);
        setMyFileList(files);
    }

    const handleVariantValidSubmit = (event, values) => {
        if (values.id > 0) {
            patchVariant(params.id, values.id, { ...values })
        } else {
            postVariant(product.id, { ...values })
        }
    }

    const onSequenceDecrease = (item) => {
        if (item.sequence - 1 < 1) return;

        item.sequence = item.sequence - 1;
        setSequence(item.sequence)

        patchImage(product.id, item.id, item)
    }

    const onSequenceIncrease = (item) => {
        if (item.sequence > 100) return;

        item.sequence = item.sequence + 1;
        setSequence(item.sequence)

        patchImage(product.id, item.id, item)
    }

    const onToggleEdit = () => {
        if (isDetailMode) {
             navigate(`/catalog-management/products/${product.id}`);
        } else {
             navigate(`/catalog-management/products/${product.id}/detail`);
        }
    }

    return (
        <>

            <PageTitle breadcrumbs={breadcrumbs} >{intl.formatMessage({ id: 'PRODUCT.ITEM.BREADCRUMB' })}</PageTitle>

            <div className="card mb-5 mb-xl-10">
                <div className="card-header card-header-stretch">
                    <h3 className="card-title">{intl.formatMessage({ id: 'PRODUCT.TITLE' })}</h3>
                    <div className="card-toolbar">
                        <PolicyChecker policies={[enumPolicies.ProductEdit, enumPolicies.ProductWrite]}>
                            <div className="d-flex align-items-center ms-5">
                                <button type="button" className="btn btn-sm btn-light btn-active-light-primary" onClick={onToggleEdit}>
                                    {!isEditing ? (
                                        <>
                                            <i className="ki-duotone ki-pencil fs-2"></i> {intl.formatMessage({ id: 'PRODUCT.DETAIL.EDITPRODUCT' }) || 'Edit'}
                                        </>
                                    ) : (
                                        <>
                                            <i className="ki-duotone ki-check fs-2"></i> {intl.formatMessage({ id: 'PRODUCT.DETAIL.DONEEDITING' }) || 'Done Editing'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </PolicyChecker>
                    </div>
                </div>
            </div>

            {/* Product General & Images */}
            <div className="row g-5 mb-5 mb-xl-10">
                <div className="col-xl-8">
                        <ProductGeneralSection 
                        product={product} 
                        intl={intl} 
                        validation={validation} 
                        categories={categories} 
                        optionValues={optionValues} 
                        productTypes={productTypes} 
                        suppliers={suppliers} 
                        onSubmit={handleValidSubmit}
                        isEditing={isEditing}
                    />
                </div>
                <div className="col-xl-4">
                    <ProductImagesSection 
                        intl={intl}
                        myFiles={myFiles}
                        images={images}
                        onDropRejected={onDropRejected}
                        handleAcceptedFiles={handleAcceptedFiles}
                        onSaveFile={onSaveFile}
                        onDeleteFile={onDeleteFile}
                        onDeleteExistFile={onDeleteExistFile}
                        onSequenceDecrease={onSequenceDecrease}
                        onSequenceIncrease={onSequenceIncrease}
                        isEditing={isEditing}
                    />
                </div>
            </div>

            {/* Variants */}
            {params.id > 0 && (
                <ProductVariantsSection 
                    product={product}
                    variants={variants}
                    intl={intl}
                    validation={validation}
                    newVariant={newVariant}
                    onVariantSubmit={handleVariantValidSubmit}
                    setVariantFormRef={(e) => (setVariantForm(e))}
                    isEditing={isEditing}
                />
            )}

            {loading && <Loader></Loader>}
        </>
    );
};



const mapStateToProps = state => {
    return {
        product: state.Product.product,
        variants: state.Product.variants,
        images: state.Product.images,
        uploadedImageId: state.Product.uploadedImageId,
        optionValues: state.Product.optionValues,
        categories: state.Product.categories,
        suppliers: state.Product.suppliers,
        models: state.Product.models,
        productTypes: state.Product.productTypes,
        loading: state.Product.loading,
        success: state.Product.success
    };
};

const mapActionsToProps = {
    clearState, getProduct, postProduct, patchProduct, uploadImage, getImages, deleteImage, patchImage, getVariants, postVariant, patchVariant, getOptionValues, getCategories, getSuppliers, getModels, getLookupValues
}

export default connect(mapStateToProps, mapActionsToProps)(Product)
